import { UI } from '@genial/components';
import { BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import { Box, Button, HStack, Pressable, useBreakpointValue, VStack } from 'native-base';
import React from 'react';

import { ItemDetailsComponentProps } from '../..';
import { PublicOffersModality } from '../PublicOffersModality';

export const PublicOffersModalities: React.FC<ItemDetailsComponentProps> = ({
  details,
  offer,
  isLoading,
}) => {
  const isMobile = useBreakpointValue({ base: true, md: false });
  const [documentsOpen, setDocumentsOpen] = React.useState(true);
  const [modalitiesOpen, setModalitiesOpen] = React.useState(true);

  const handleChangeDocumentsOpen = () => {
    setDocumentsOpen((state) => !state);
  };

  const handleChangeModalitiesOpen = () => {
    setModalitiesOpen((state) => !state);
  };

  const handleOpenLink = (url: string) => {
    window.open(url, '_blank');
  };

  return (
    <VStack space={Spacing['stack.xxxs']} py={Spacing['stack.xxxs']}>
      {isLoading || !details ? (
        <UI.Skeleton height="56px" borderRadius={'4px'} />
      ) : (
        <Box bg={Color.background} px={Spacing['inline.xxxs']} borderRadius={BoxRadius.sm}>
          <Pressable w="full" py={Spacing['stack.xxxs']} onPress={handleChangeModalitiesOpen}>
            <HStack justifyContent="space-between" alignItems="center">
              <UI.Text variant="semibold">Modalidades</UI.Text>
              <UI.Icon name={modalitiesOpen ? 'ChevronUp' : 'ChevronDown'} size="xs" />
            </HStack>
          </Pressable>
          {!!modalitiesOpen && (
            <VStack space={Spacing['stack.xxxs']} pb={Spacing['stack.xxxs']}>
              {details.modalities.map((modality, index) => (
                <>
                  <PublicOffersModality
                    key={`modality-${index}`}
                    modality={modality}
                    isMobile={isMobile}
                  />
                  {index !== details.modalities.length - 1 && (
                    <Box h="1px" w={'full'} bg={'neutral.lightest'} />
                  )}
                </>
              ))}
            </VStack>
          )}
        </Box>
      )}

      <Box bg={Color.background} px={Spacing['inline.xxxs']} borderRadius={BoxRadius.sm}>
        <Pressable w="full" py={Spacing['stack.xxxs']} onPress={handleChangeDocumentsOpen}>
          <HStack justifyContent="space-between" alignItems="center">
            <UI.Text variant="semibold">Documentos</UI.Text>
            <UI.Icon name={documentsOpen ? 'ChevronUp' : 'ChevronDown'} size="xs" />
          </HStack>
        </Pressable>
        {!!documentsOpen && (
          <VStack space={Spacing['stack.xxxs']} pb={Spacing['stack.xxxs']}>
            {offer.documents.map((document, id) => (
              <Button
                key={`document-${id}`}
                onPress={() => handleOpenLink(document.fileUrl)}
                variant="textLink"
                p={0}
                isDisabled={!document.fileAvailable}
                _text={{
                  textTransform: 'none',
                  fontFamily: Typography['fontfamily.base.semibold'],
                  fontSize: Typography['fontsize.xs'],
                }}
                justifyContent="start"
                leftIcon={
                  <UI.Icon name="Download" size="xxxs" color={Color['brand.tertiary.principal']} />
                }>
                {document.fileName}
              </Button>
            ))}
          </VStack>
        )}
      </Box>
    </VStack>
  );
};
